import { useMemo, useState } from "react";
import { ContainerAutorizacionOrden } from "./localStyle";
import ordenImage from "_+_Portal/assets/images/generico/OrdenMiniatura.png";
import { Camera, CameraResultType } from "@capacitor/camera";
import LayoutCamara from "../LayoutCamara/LayoutCamara";

const AutorizacionOrden = ({ finalizarProceso, idTurno }) => {
  const [step, setStep] = useState("tomarFoto"); // tomarFoto | capturaTerminal | confirmacionOrden
  const [imageCamera, setImageCamera] = useState([]);

  // En terminal/tablet la cámara nativa de Capacitor no funciona; usamos la webcam
  // vía LayoutCamara (getUserMedia), igual que FrenteOrden al subir la orden médica.
  const isTabletDesktop = useMemo(() => {
    return typeof window !== "undefined" && window.innerWidth >= 768;
  }, []);

  // Arma el dto de autorización a partir de base64 + tipo y finaliza el proceso.
  const finalizarAutorizacion = (base64, tag) => {
    const dto = {
      binario: base64,
      idRemoto: idTurno,
      tag,
      autocheck: true,
    };
    finalizarProceso(dto, "autorizacionOrden");
  };

  // Botón "Subir Autorización": en terminal abre la cámara webcam (LayoutCamara);
  // en celular dispara la cámara nativa de Capacitor (comportamiento original).
  const subirAutorizacion = () => {
    if (isTabletDesktop) {
      setStep("capturaTerminal");
      return;
    }
    const takePicture = async () => {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
      });
      let lista = [...imageCamera];
      lista[0] = {
        base64: image.dataUrl.replaceAll(
          `data:image/${image.format};base64,`,
          "",
        ),
        type: image.format,
      };
      setImageCamera(lista);
      setStep("confirmacionOrden");
    };
    takePicture();
  };

  // Terminal: captura por webcam. LayoutCamara/CapturaCamara ya confirma la imagen
  // en su paso interno, así que recibimos el dataURL definitivo y finalizamos.
  const handleCanvasCapture = (dataUrl) => {
    const partes = dataUrl.split(",");
    const tag = partes[0].replace("data:image/", "").replace(";base64", "");
    finalizarAutorizacion(partes[1], tag);
  };

  // Celular: confirmación de la foto tomada con Capacitor.
  const handleClickConfirmarOrden = (isCorrect) => {
    if (isCorrect) {
      finalizarAutorizacion(imageCamera[0].base64, imageCamera[0].type);
    } else {
      setStep("tomarFoto");
    }
  };

  const renderStep = () => {
    switch (step) {
      case "tomarFoto":
        return (
          <ContainerAutorizacionOrden
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <span className={isTabletDesktop ? "rb24t" : "rb18m"}>
              Imagen de autorización
            </span>
            <span className={isTabletDesktop ? "rb24t" : "rb18m"}>
              El turno requiere autorización, ingrese una imagen de la misma.
            </span>
            <img
              className="first-image"
              src={ordenImage}
              alt="ordenes de autocheckin"
            />
            <div className="container-btn">
              <button
                onClick={() => subirAutorizacion()}
                className="bgc-primary"
              >
                Subir Autorización
              </button>
            </div>
          </ContainerAutorizacionOrden>
        );
      case "capturaTerminal":
        return (
          <ContainerAutorizacionOrden
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <LayoutCamara
              onCapture={handleCanvasCapture}
              subtituloInicial="Por favor posicione la autorización debajo de la cámara y tome la foto."
              tituloConfirmacion="¿Se ve correctamente la autorización?"
              subtituloConfirmacion="Revise que la autorización se lea claramente"
            />
          </ContainerAutorizacionOrden>
        );
      case "confirmacionOrden":
        return (
          <ContainerAutorizacionOrden
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <span>Imagen de autorización</span>
            <span>
              El turno requiere autorización, ingrese una imagen de la misma.
            </span>
            <img
              className="first-image"
              src={`data:image/${imageCamera[0].type};base64,${imageCamera[0].base64}`}
              alt="ordenes de autocheckin"
            />
            <div className="btn-container">
              <button
                onClick={() => handleClickConfirmarOrden(false)}
                className="bgc-danger"
              >
                NO
              </button>
              <button
                onClick={() => handleClickConfirmarOrden(true)}
                className="bgc-broccoli"
              >
                SI
              </button>
            </div>
          </ContainerAutorizacionOrden>
        );
      default:
        return <h1>Error en autorización</h1>;
    }
  };

  return renderStep();
};

export default AutorizacionOrden;
